import { render, staticRenderFns } from "./NewspaperLookup.vue?vue&type=template&id=4d3af8d9&scoped=true&"
import script from "./NewspaperLookup.vue?vue&type=script&lang=js&"
export * from "./NewspaperLookup.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./NewspaperLookup.vue?vue&type=style&index=1&id=4d3af8d9&prod&lang=scss&"
import style2 from "./NewspaperLookup.vue?vue&type=style&index=2&id=4d3af8d9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3af8d9",
  null
  
)

export default component.exports